const CryptoJS = require("crypto-js");

export function hmac256(message: string = "", key: string = ""): string {
  return CryptoJS.HmacSHA256(message, key).toString(CryptoJS.enc.Base64);
}

export const password = "5olusipay";
export const respassword = "s0lusipay";
export const regexp = /^[0-9a-zA-Z/\b]+$/;
export const regexpamount = /^$|^[1-9][0-9]{0,9}$/;
export const regexpnumber = /^[0-9]+$/;
function getRandomString(length: number, char?: string): string {
  const characters = char ? char : "abcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export function sha256(message: string): string {
  return CryptoJS.SHA256(message).toString(CryptoJS.enc.Hex);
}

export function isJsonString(str: any): boolean {
  try {
    JSON.parse(str);
    return true; //
  } catch (e) {
    return false;
  }
}

export function decryptBase64(message: string) {
  const paramBase64 = CryptoJS.enc.Base64.parse(message);
  const result = CryptoJS.enc.Utf8.stringify(paramBase64);
  return JSON.parse(result);
}

export function encryptBase64(params: string): string {
  const CryptoJS = require("crypto-js");
  const paramsArray = CryptoJS.enc.Utf8.parse(params);
  const paramsBase64 = CryptoJS.enc.Base64.stringify(paramsArray);
  return paramsBase64;
}

export const rand3 = getRandomString(5);
export const rand1 = getRandomString(4);
export const rand2 = getRandomString(4);
export const partnerOba = new Set(["ASM", "AMD"]);

export const randNum = getRandomString(3, "567980");

export const decodeBase64UrlSafe = (param: string) => {
  // Restore padding if needed
  let base64 = param.replace(/-/g, "+").replace(/_/g, "/");

  // Add padding back if it was stripped
  const padLength = 4 - (base64.length % 4);
  if (padLength !== 4) {
    base64 += "=".repeat(padLength);
  }

  const parsedWordArray = CryptoJS.enc.Base64.parse(base64);
  return CryptoJS.enc.Utf8.stringify(parsedWordArray);
};

export const StatusTransaction = [
  {
    isFinish: "0",
    isExpired: "",
    status: "OPEN",
    ket: "Menunggu Ditransfer",
    color: "statusYellow",
    id: "0",
  },
  {
    isFinish: "0",
    isExpired: "",
    status: "SUCCESS",
    ket: "Sedang dalam Proses",
    color: "statusYellow",
    id: "3",
  },
  {
    isFinish: "1",
    isExpired: "",
    status: "SUCCESS",
    ket: "Berhasil",
    color: "statusGreen",
    id: "1",
  },
  {
    isFinish: "1",
    isExpired: "",
    status: "REFUND",
    ket: "Dikembalikan",
    color: "statusRed",
    id: "2",
  },
  {
    isFinish: "",
    isExpired: "2",
    status: "SUCCESS",
    ket: "Sedang dalam Proses",
    color: "statusYellow",
    id: "3",
  },
  {
    isFinish: "2",
    isExpired: "",
    status: "SUCCESS",
    ket: "Sedang dalam Proses",
    color: "statusYellow",
    id: "3",
  },
  {
    isFinish: "2",
    isExpired: "2",
    status: "REFUND",
    ket: "Gagal Dikembalikan",
    color: "statusRed",
    id: "5",
  },
  {
    isFinish: "2",
    isExpired: "",
    status: "CLOSED",
    ket: "Kedaluwarsa",
    color: "statusRed",
    id: "4",
  },
  {
    isFinish: "3",
    isExpired: "",
    status: "CLOSED",
    ket: "Gagal",
    color: "statusRed",
    id: "6",
  },
  {
    isFinish: "3",
    isExpired: "",
    status: "SUCCESS",
    ket: "Sedang dalam Proses",
    color: "statusYellow",
    id: "3",
  },
  {
    isFinish: "1",
    isExpired: "",
    status: "CLOSED",
    ket: "Kedaluwarsa",
    color: "statusRed",
    id: "4",
  },
  {
    isFinish: "",
    isExpired: "",
    status: "",
    ket: "",
    color: "",
    id: "",
  },
];

export const getTransactionStatus = (item: any) => {
  for (const data of StatusTransaction) {
    if (
      (item.isFinish === data.isFinish && item.statusPay === data.status) ||
      (item.isExpired === data.isExpired && item.statusPay === data.status)
    ) {
      return { ket: data.ket, color: data.color };
    }
  }
  return { ket: "", color: "" };
};

export const getTransactionColor = (status: string) => {
  for (const data of StatusTransaction) {
    if (data.status.toLowerCase() === status.toLowerCase()) {
      return data.color;
    }
  }
  return "";
};

export const groupTransactionsByDate = (transactions: any[]) => {
  if (!transactions || transactions.length === 0) {
    return { groupCounts: [], groups: [], totalCount: 0 };
  }

  const groupCounts: number[] = [];
  const groups: string[] = [];
  let currentGroupCount = 0;
  let lastDate = transactions[0].transactionDate.slice(0, -6);

  transactions.forEach((transaction, index) => {
    const currentDate = transaction.transactionDate.slice(0, -6);
    if (lastDate === currentDate) {
      currentGroupCount++;
    } else {
      groupCounts.push(currentGroupCount);
      groups.push(lastDate);

      lastDate = currentDate;
      currentGroupCount = 1;
    }

    // Push the last group
    if (index === transactions.length - 1) {
      groupCounts.push(currentGroupCount);
      groups.push(lastDate);
    }
  });

  return { groupCounts, groups, totalCount: transactions.length };
};

export const statusList = [
  {
    id: "0",
    ket: "Menunggu Ditransfer",
  },
  {
    id: "1",
    ket: "Berhasil",
  },
  {
    id: "2",
    ket: "Dikembalikan",
  },
  {
    id: "3",
    ket: "Sedang Dalam Proses",
  },
  {
    id: "4",
    ket: "Kedaluwarsa",
  },
  {
    id: "5",
    ket: "Gagal Dikembalikan",
  },
  {
    id: "6",
    ket: "Gagal",
  },
];
